<template>
  <EquipmentRow
    :key="`${props.stack || 'default'}-${sealMotorOil?.id || 'none'}`"
    data-cy="seal-motor-oil-row"
  >
    <template #left></template>
    <template #default="{ toggle }">
      <AddRemoveButtons
        style="width: 300px"
        data-cy="seal-motor-oil-row-add-remove-buttons"
        :hide-add-below="true"
        :disable-remove="!sealMotorOil?.id"
        @remove="
          props.stack === 'lower'
            ? equipmentForm.update({
                r_lower_seal_motor_oil: null,
                lower_seal_motor_oil_id: null
              } as Partial<typeof equipmentForm.data.value>)
            : equipmentForm.update({
                r_seal_motor_oil: null,
                seal_motor_oil_id: null
              })
        "
      >
        <template #middle-content>
          <EquipmentPanel
            class="flex-grow-1"
            data-cy="seal-motor-oil-row-equipment-panel"
            :rule-names="['seal_motor_oil_temp_exceeded']"
            @toggle="toggle"
          >
            <template #header>
              <span>{{
                isScenarioEspShore
                  ? "Seal Motor Oil"
                  : "Thrust Chamber Motor Oil"
              }}</span>
            </template>
            <template v-if="sealMotorOil" #trigger>
              {{ sealMotorOil.name }}
            </template>
          </EquipmentPanel>
        </template>
      </AddRemoveButtons>
    </template>
    <template #expand="{ toggle }">
      <SealMotorOilSearchView
        :is-admin="false"
        data-cy="seal-motor-oil-row-seal-motor-oil-search-view"
        @select="handleSealMotorOilSelect($event, toggle)"
      />
    </template>
    <template #right></template>
  </EquipmentRow>
</template>

<script setup lang="ts">
import { computed, provide } from "vue";
import SealMotorOilSearchView from "./SealMotorOilSearchView.vue";
import EquipmentRow from "@/components/scenarios/EquipmentRow.vue";
import EquipmentPanel from "@/components/scenarios/EquipmentPanel.vue";
import { injectStrict } from "@/utils/utils";
import {
  equipmentFormKey,
  scenarioKey
} from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import AddRemoveButtons from "@/components/AddRemoveButtons.vue";
import type { Seal_Motor_Oil } from "gql/api";
import { Sizing_Pumping_Type_Enum } from "gql/api";
import type { StackLocation } from "@/components/equipment/d";

const props = defineProps<{
  stack?: StackLocation;
}>();

const scenario = injectStrict(scenarioKey);
const equipmentForm = injectStrict(equipmentFormKey);
const equipment = computed(() => equipmentForm.data.value);

// Stack-aware seal motor oil selection
const sealMotorOil = computed(() => {
  if (props.stack === "lower") {
    return equipment.value.r_lower_seal_motor_oil;
  }
  return equipment.value.r_seal_motor_oil;
});

const isScenarioEspShore = computed(
  () => scenario.value?.pumping_type === Sizing_Pumping_Type_Enum.EspOnShore
);

provide(
  "selected-equipment-id",
  computed(() => sealMotorOil.value?.id)
);

function handleSealMotorOilSelect(
  selectedSealMotorOil: Seal_Motor_Oil,
  toggle: () => void
): void {
  toggle();
  if (props.stack === "lower") {
    equipmentForm.update({
      r_lower_seal_motor_oil: selectedSealMotorOil,
      lower_seal_motor_oil_id: selectedSealMotorOil?.id
    } as Partial<typeof equipmentForm.data.value>);
  } else {
    equipmentForm.update({
      r_seal_motor_oil: selectedSealMotorOil,
      seal_motor_oil_id: selectedSealMotorOil?.id
    });
  }
}
</script>
